import { Component, inject, signal } from '@angular/core';
import { IMyOskSubscriptonsVm } from '../../../../api/my-osk-subscriptons-vm.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { eModalRoles } from '../../../shared/models/modals';
import { IMyOskStudentVm } from '../../../../api/my-osk-student-vm.model';
import { IStudentAssignedSubscriptionPlanResultIm } from '../../../../api/student-assigned-subscription-plan-result-im.model';
import { StudentAssignedSubscriptionPlanService } from '../../../../api/api-services/student-assigned-subscription-plan.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-students-assign-subscription',
  templateUrl: './students-assign-subscription.component.html',
  styleUrl: './students-assign-subscription.component.scss',
})
export class StudentsAssignSubscriptionComponent {
  private _studentAssignedSubscriptionPlanService = inject(StudentAssignedSubscriptionPlanService);
  private _messageService = inject(MessageService);
  private _config = inject(DynamicDialogConfig);
  private _dialogRef = inject(DynamicDialogRef);

  public data: {
    studentDetails: IMyOskStudentVm
  } = this._config.data;

  public loading: boolean = false;
  missingSubscriptionMessage = signal<string | null>(null);
  selectedSubscription = signal<IMyOskSubscriptonsVm[]>([]);

  closeDialog(status: eModalRoles = eModalRoles.CLOSE): void {
    this._dialogRef.close(status);
  }

  assignSubscription(): void {
    const subscriptionPlanGuid = this.getSubscriptionGuid();
    if (!subscriptionPlanGuid) {
      this.missingSubscriptionMessage.set('Przydziel abonament dla kursanta');
      return;
    }
    this.loading = true;

    const payload: IStudentAssignedSubscriptionPlanResultIm = {
      oskStudentGuid: this.data.studentDetails.guid,
      subscriptionPlanGuid
    }

    this._studentAssignedSubscriptionPlanService.post(payload).subscribe({
      next: () => {
        this.loading = false;
        this._messageService.add({
          severity: 'success',
          summary: 'Sukces',
          detail: 'Przydzielono abonament',
        });
        this.closeDialog(eModalRoles.SUCCESS);
      },
      error: () => {
        this.loading = false;
        this._messageService.add({
          severity: 'error',
          summary: 'Błąd',
          detail: 'Wystąpił błąd. Spróbuj ponownie później.',
        });
      }
    })
    console.log('object', payload);
  }

  
  private getSubscriptionGuid(): string | null {
    if (this.selectedSubscription().length > 0) {
      return this.selectedSubscription()[0].planGuid;
    }
    return null;
  }
}
